import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'list',
		'item',
		'itemCounter',
	]

	connect() {
	}

	getItemCount() {
		return this.itemTargets.length
	}

	addItem(event) {
		if (event.currentTarget.disabled) return
		const data = event.currentTarget.dataset
		this.listTarget.prepend(this.renderItem(data))
	}

	itemTargetConnected(element) {
		this.updateEmptyPlaceholder()
		this.listTarget.classList.remove('border-danger')
		this.updateItemCounter()
	}

	itemTargetDisconnected(element) {
		this.updateEmptyPlaceholder()
		if (this.itemTargets.length == 1) this.itemTargets[0].classList.add('border-danger')
		this.updateItemCounter()
	}

	updateItemCounter() {
		if (this.hasItemCounterTarget) {
			this.itemCounterTarget.innerText = this.itemTargets.filter(item => !item.classList.contains('empty-placeholder')).length
		}
	}

	removeItem(event) {
		event.currentTarget.closest("li").remove()
	}

	updateEmptyPlaceholder() {
		const emptyPlaceholder = this.itemTargets.find(item => item.classList.contains('empty-placeholder'))
		if (this.getItemCount() > 1) {
			emptyPlaceholder.classList.add('d-none')
		} else {
			emptyPlaceholder.classList.remove('d-none')
		}
	}

	sortItems() {
	}

	// This method is easy to override in a subclass for custom html list-group-item elements.
	renderItem(data) {
		const li = document.createElement('li')
		li.classList.add('list-group-item')
		li.innerHTML =
`<div class="d-flex flex-row justify-content-center align-items-center">
	<input type="hidden" name="session[session_participant][participant_id]" value="${data.id}">
	<div>${data.name}</div>
	<div class="ms-auto">
		<button type="button" class="btn btn-sm btn-outline-danger" data-action="list-group#removeItem">
			<div class="fa fas fa-times"></div>
			Delete
		</button>
	</div>
</div>`
		return li
	}

}

